export default __webpack_public_path__ + "static/media/Download_FFEAE5.810a9811.svg";